import React, { FC } from 'react'
import { FieldArrayWithId } from 'react-hook-form'
import { IntegrationConfig } from '../../api/shared'
import { JiraIntegrationForm } from '../jira-form-schema'
import { IntegrationRow, IntegrationRowProps } from './integration-row'

export interface IntegrationRowsProps
  extends Omit<IntegrationRowProps, 'integrationValue' | 'update'> {
  fields: Array<FieldArrayWithId<JiraIntegrationForm, 'integrations', 'id'>>
  update: (index: number, value: IntegrationConfig) => void
  remove: (index: number) => void
}
export const IntegrationRows: FC<IntegrationRowsProps> = ({
  fields,
  update,
  resolutions,
  statuses,
  remove
}) => {
  const removeThisFieldRow = (index) => {
    return () => remove(index)
  }
  return (
    <div data-e2e="integration-rows">
      {fields.map((field, index) => (
        <IntegrationRow
          key={`integration-row-${index}`}
          update={(value: IntegrationConfig) => {
            update(index, value)
          }}
          integrationValue={field}
          removeFieldRow={
            fields.length > 1 ? removeThisFieldRow(index) : undefined
          }
          resolutions={resolutions}
          statuses={statuses}
        />
      ))}
    </div>
  )
}
